import withAPIAction from '../../../utils/withAPIAction'
import {
  getCheckListAction,
  getCheckListByIdAction,
  deleteCheckListAction,
  createCheckListAction,
  updateCheckListAction,
  getProjectAction,
} from './actions'

import { CreateCheckListReq, UpdateCheckListReq } from './types'

// get list
export const getCheckList = (
  Page: number,
  RowPerPage: number,
  TextFilter: string = ''
) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetAuditPlanCheckList',
    data: {
      UserEmail: state.sensitive.userEmail,
      Page,
      RowPerPage,
      TextFilter,
    },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getCheckListAction)
}

// get detail
export const getCheckListById = (CheckListID: number) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetAuditPlanCheckListById',
    data: { CheckListID, UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getCheckListByIdAction)
}

// create check list
export const createCheckList = (data: CreateCheckListReq) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'CreateAuditPlanCheckList',
    data,
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(createCheckListAction)
}

// update check list
export const updateCheckList = (data: UpdateCheckListReq) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'UpdateAuditPlanCheckList',
    data,
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(updateCheckListAction)
}

// delete check list
export const deleteCheckList = (CheckListID: number) => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'DeleteAuditPlanCheckList',
    data: { CheckListID, UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(deleteCheckListAction)
}

export const getProjectSelector = () => {
  return withAPIAction(state => ({
    method: 'POST',
    path: 'GetProjectOnAuditPlanCheckList',
    data: { UserEmail: state.sensitive.userEmail },
    token: `Bearer ${state.sensitive.apiToken}`,
  }))(getProjectAction)
}
